export enum DRIVESCAN_MODEL {
  PF7000 = 'PF7000',
  T02 = 'T02',
  T06 = 'T06',
  T08 = 'T08',
  S09 = 'S09',
  S12 = 'S12',
  S15 = 'S15',
  LV01 = 'LV01',
  OTHER = 'other',
}
